import { h } from 'preact';
import { useEffect, useRef } from 'preact/hooks';
import { waitForElement } from 'utils/wait-for-element';

export const ShopPay = ({ price, available }) => {
  if (!available) return false;
  const ref = useRef(null);

  const init = async () => {
    if (!ref.current) return;
    const element = await waitForElement('shopify-payment-terms');
    ref.current.append(element);
  };

  useEffect(() => {
    init();
  }, [price, ref]);

  return (
    <div ref={ref}>
      {available && ref.current?.children.length > 0 && (
        <div className="mb-5 text-body-3">
          <div className="shopify-payment-terms" />
        </div>
      )}
    </div>
  );
};
